var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{ref:"button",attrs:{"size":"small","outlined":true,"loading":_vm.loading},on:{"click":_vm.send}},[_vm._v("Send Online Request")])}
var staticRenderFns = []

export { render, staticRenderFns }